// inv/src/pages/authentication/InvoiceDownloadButton.jsx
import { API_URL } from '../../config';

export default function InvoiceDownloadButton({ transactionId }) {
  const handleDownload = () => {
    window.location.href =
      `${API_URL}/paddle/transactions/${transactionId}/invoice?disposition=attachment`;
  };

  return (
    <button
      type="button"
      onClick={handleDownload}
      className="cursor-pointer btn btn-xs"
    >
      Download
    </button>
  );
}